import mushroom from "./api/dulich-api";
import LanguageService from '@/service/LanguageService';
import { blockUi, unblockUi } from '../shared/utils';

window.requestCount = 0;

let ExtensionService = {};


ExtensionService.urlImg = window.MyConfig.hostApi + "file/thumb?id=";
ExtensionService.urlSurveyImg = window.MyConfig.surveyPath + "file/thumb?id=";
ExtensionService.urlFile = window.MyConfig.hostApi + "file/download?id=";
ExtensionService.urlFilesTemplate = {
    DsKhachDuLich: "/files/template/DanhSachKhachDuLichMau.xlsx",
    DsKDLMau: "/files/template/DanhSachKDLMau.xlsx",
    DsDDATMau: "/danhsach.xlsx",
    Hdsd: "/HuongDanSuDung-App.pdf",
    HdsdDownload: "/HuongDanSuDung-App.pdf",
    HdsdCsdvdl: "/HuongDanSuDung-Web.pdf",
    HdsdCsdvdlDownload: "/HuongDanSuDung-Web.pdf",
    HddkCtlh: "/HDSDSafectlhVconvert.pdf",
    QĐ718_2017: "files/DieuKhoanTrangVang/QD718-2017.pdf",
    TT262014BVHTTDL: "/files/DieuKhoanTrangVang/TT262014BVHTTDL.pdf"
};
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
ExtensionService.urlHdsdAPP = isMobile ? `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(location.protocol + "//" + location.host + ExtensionService.urlFilesTemplate.Hdsd)}&embedded=true` : ExtensionService.urlFilesTemplate.Hdsd;
ExtensionService.urlHdsdCsdvdl = isMobile ? `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(location.protocol + "//" + location.host + ExtensionService.urlFilesTemplate.HdsdCsdvdl)}&embedded=true` : ExtensionService.urlFilesTemplate.HdsdCsdvdl;
ExtensionService.urlHddkCtlh = isMobile ? `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(location.protocol + "//" + location.host + ExtensionService.urlFilesTemplate.HddkCtlh)}&embedded=true` : ExtensionService.urlFilesTemplate.HddkCtlh;
ExtensionService.urlSurveyFile =
    window.MyConfig.surveyPath + "file/download?id=";

ExtensionService.upload = (rawDataFile, tags) => {
    blockUi();
    return mushroom.$file
        .uploadAsync({
            file: rawDataFile.raw, // required
            name: rawDataFile.name, // optional
            tags: tags ? tags.split(",") : []
        })
        .then(response => {
            unblockUi();
            return response;
        })
        .catch(error => {
            unblockUi();
            window.toastr.error(LanguageService.lang.c_uploadError);
            throw error;
        });
};

export default ExtensionService;